import React, { FC, useState, useEffect, memo } from "../../../lib/teact/teact";
import Spinner from "../../ui/Spinner";
import MessageEditor from "../message/messageEditor";
import { updateHanMucJson } from "../redux/contactsSlice";
import { ContactsApi } from "../restapi/contactsApi";
import Parser from "../restapi/parser";
import store from "../store";
import Loading from "../ui/loading";
import './hanMuc.scss'
import HanMucItem from "./hanMucItem";
type OwnProps = {
    giaThuongList: any;
}

const HanMuc: FC<OwnProps> = ({
    giaThuongList,
}) => {
    const [state, setState] = useState({
        htmlError: "",
        errorTextToUser: "",
        rawText: "",
        hanMucJson: {},
        isLoading: true,

    })
    function handleTextChange(html: string, rawText: string) {
        setState(prev => ({ ...prev, rawText: rawText }))

    }
    async function handleParseMessage() {
        const currentContact: any = store.getState()?.contact?.currentContact
        const contactId = currentContact.contactId
        const payload = {
            body: state.rawText,
            date: store.getState().global.workDate,
            time: "00:00:59",
            type: 1,
            contactId: contactId,
            mien: "BAC",
            curMien: "BAC",
            getCompactData: 1,
            getRawData: 0,
            mienCuPhapId: 1,
            tachXienMay: 3,
            soBoSo: 10,
        }
        let result = await Parser.parseCanChuyenMessage(payload)
        let html = result.data.html
        if (html == "")
            html = result.data.bodyViet
        setState(prev => ({ ...prev, htmlError: html, errorTextToUser: result.responseText }))
        if (result.data.parseStatus == "parseOK") {
            const payload = {
                contactId: contactId,
                JSON: JSON.stringify(result.data.compactData),
                hanMucText: state.rawText,
            }
            ContactsApi.saveHanMucJson(payload).then(ret => {
                console.log(ret)
            })
            const hanMucJsonArr = store.getState().contact.hanMucJson
            let hanMuc = { contactId: contactId, hanMucText: state.rawText, json: JSON.stringify(result.data.compactData) }
            store.dispatch(updateHanMucJson({ hanMucJson: hanMuc, contactId: contactId }))

        }
    }
    useEffect(() => {
        let hanMucJsonArr: any = store.getState().contact.hanMucJson
        const contact: any = store.getState().contact.currentContact
        const contactId = contact.contactId
        let hanMuc = hanMucJsonArr[contactId + ""]
        if (hanMuc == undefined) {
            const data = ContactsApi.getHanMucJson(contactId).then((result) => {
                const data = result.data
                hanMuc = data
                if (hanMuc.contactId == 0) { // chưa có bản ghi nào
                    hanMuc.contactId = contactId
                }

                const payload = { contactId: contactId, hanMucJson: hanMuc }
                store.dispatch(updateHanMucJson(payload))
                setState(prev => ({
                    ...prev, hanMucJson: hanMuc, htmlError: hanMuc.hanMucText, rawText: hanMuc.hanMucText,
                    isLoading: false
                }))
            })
        }
        else {
            setState(prev => ({
                ...prev, hanMucJson: hanMuc, htmlError: hanMuc.hanMucText, rawText: hanMuc.hanMucText
                , isLoading: false
            }))

        }
    }, [])
    return (
        <div className="hanmuc-main">
            {
                giaThuongList.length > 0 ? giaThuongList.map((item: any, index: any) => {
                    return (<div key={"gtitem" + index}>
                        <HanMucItem item={item} index={index} />
                    </div>
                    )
                }) : (<Spinner className="center-item" />)


            }
            {
                state.isLoading ? <Loading />
                    : <div style={"padding:10px"}>
                        <MessageEditor msgType={1}
                            onTextChange={handleTextChange}
                            maxHeight="5rem"
                            hidenFontSizeSetting={false}
                            htmlError={state.htmlError}
                            errorTextToUser={state.errorTextToUser}
                            showSaveButton
                            onParseMessage={handleParseMessage}
                        ></MessageEditor>
                    </div>
            }

        </div>
    );
}

export default memo(HanMuc);
